import React from "react";
import { InfoOutlined } from "@material-ui/icons";
import { COMMON_WIDTH_RESOLUTIONS } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";
import classnames from "classnames";
import { useCustomFeatureRequest } from "./utils/hooks/useCustomFeatureRequest";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import {
  mergeStatusConfig,
  getCurrentStatusConfig,
  applyCustomConfigOverrides,
} from "./utils/CustomFeatureRequestFooter.utils";

export const CustomFeatureRequestFooter = ({
  config,
  customConfig = {},
  statusConfig = {},
}) => {
  const { handleRequestClick, subSectionConfig } =
    useCustomFeatureRequest(config);

  // Merge default config with custom status config
  const mergedConfig = mergeStatusConfig(statusConfig);

  // Get current status config
  const currentStatus = subSectionConfig?.status;
  const requestVerificationConfig = getCurrentStatusConfig(
    mergedConfig,
    currentStatus
  );

  // Final override with customConfig for backward compatibility
  const finalConfig = applyCustomConfigOverrides(
    requestVerificationConfig,
    customConfig
  );

  const { text, backgroundColor, btn } = finalConfig;

  return (
    <div className="tw-flex tw-flex-col tw-w-[90%] tw-mx-5 md:tw-mx-8 tw-mb-6 tw-mt-2 md:tw-mt-[-1.5rem]">
      <div
        className="tw-flex tw-rounded-md tw-p-[14px_12px_14px_10px] tw-justify-between"
        style={{ backgroundColor }}
      >
        <div className="tw-flex tw-items-center tw-gap-2">
          <InfoOutlined className="tw-w-[18px] tw-h-[18px]" />
          <div
            className="tw-text-[12px] tw-font-normal tw-leading-4 tw-tracking-[0.24px]"
            style={{ color: text.color }}
          >
            {text.title}
          </div>
        </div>
        {btn?.hidden !== true && (
          <div
            className={classnames(
              "tw-flex tw-items-center tw-justify-center tw-rounded tw-border-solid tw-border-[1.5px] tw-bg-transparent tw-p-[6px_12px] tw-cursor-pointer tw-text-[12px] tw-font-medium tw-leading-normal",
              {
                "tw-pointer-events-none tw-cursor-not-allowed tw-border-0 tw-gap-2 tw-p-[6px_0px]":
                  btn.className === "inProgressBtn",
              }
            )}
            style={{ borderColor: btn.color, color: btn.color }}
            onClick={handleRequestClick}
          >
            {btn.icon && (
              <ExlyImage
                src={btn.icon}
                fetchWidth={COMMON_WIDTH_RESOLUTIONS}
                className="tw-w-[16px] tw-h-[16px]"
              />
            )}
            <div style={{ color: btn.color }}>{btn.btnText}</div>
          </div>
        )}
      </div>
    </div>
  );
};
